import React from "react";
import { withTranslation } from 'react-i18next';
import { Utilities } from "./utilities";
  
class UtilitiesParent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
    
        }
      }
  render() {
    return <Utilities {...this?.props}/> ;
  }
}

export default withTranslation('utilities')(UtilitiesParent);
